<div id="close-image" (click)="closeDialogBox()"><img src="../../../../../../../assets/images/food-subscription/close.png" alt=""></div>
<div class="subscription-text">Successfully Subscribed</div>
<div id="right-sign"><img src="../../../../../../../assets/images/food-subscription/right-sign.svg" alt=""></div>
<div class="success-text">
    <div>You have successfully subscribed the plan.</div>
    <div class="view-details-btn" (click)="viewSubscriptionDetails()">View Details</div>
</div>